export default __webpack_public_path__ + "static/media/chart-nav-btn-hover.svg";